module.exports = __webpack_public_path__ + "img/Banner_02_Arreglalo_Febrero_desk.d5a380de.jpg";